/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type Event_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly domains: ReadonlyArray<string | null> | null;
    readonly primaryOrgCalendar: string;
    readonly primaryOrgEmail: string;
    readonly shadowCalendarSettingsErrorable: {
        readonly __typename: "ShadowCalendarSettings";
        readonly enabled: boolean;
        readonly shadowCalendarId: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly orgAccountingPeriod: {
        readonly __typename: "OrgAccountingPeriod";
        readonly periodRange: {
            readonly minDate: string;
            readonly maxDate: string;
        };
        readonly quotaMax: number;
        readonly quotaUsed: number;
        readonly enforcementState: EnforcementStateEnum;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"AutopilotFormSaveOnEdit_org" | "AvatarRowNew_org" | "EventSummary_org" | "EventSmartHoldInfo_org" | "EventTeam_org">;
    readonly " $refType": "Event_org";
};
export type Event_org$data = Event_org;
export type Event_org$key = {
    readonly " $data"?: Event_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Event_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "Event_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domains",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgEmail",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "shadowCalendarSettingsErrorable",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shadowCalendarId",
                                "storageKey": null
                            }
                        ],
                        "type": "ShadowCalendarSettings",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgAccountingPeriod",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DateRange",
                                "kind": "LinkedField",
                                "name": "periodRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minDate",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxDate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaMax",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaUsed",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enforcementState",
                                "storageKey": null
                            }
                        ],
                        "type": "OrgAccountingPeriod",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotFormSaveOnEdit_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AvatarRowNew_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummary_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSmartHoldInfo_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventTeam_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '967b62686ad2c9620d4a9d6e789b766e';
export default node;
